import React from "react";
import GPSCoordinates from "../../models/GPSCoordinates";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Location to display.
     */
    geolocation: GPSCoordinates
}

/**
 * Formats and displays geolocation information.
 * @author Alizée Grand
 * @version 1.1
 * @creation 18/05/2022
 * @last_update 11/07/2022
 **/
class DisplayLatLong extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <ul>
                <li><b>{getTranslation("display.location.lat")}</b> : {this.props.geolocation.latitude}</li>
                <li><b>{getTranslation("display.location.long")}</b> : {this.props.geolocation.longitude}</li>
            </ul>

        );

    };

}

export default withTranslation()(DisplayLatLong);
